import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useApi } from "@/lib/api";
import { EventCard } from "@/components/site/EventCard";
import { SectionHeading } from "@/components/site/SectionHeading";
import { Container, LoadingGrid } from "@/components/site/PageHeader";

export const UpcomingSection = () => {
  const upcoming = useApi("/events", { when: "upcoming", limit: 6 });
  const past = useApi("/events", { when: "past", limit: 6 });
  const hasUpcoming = (upcoming.data || []).length > 0;
  const events = [...(upcoming.data || []), ...(past.data || [])].slice(0, 6);

  return (
    <section className="py-24 md:py-32" data-testid="home-upcoming-section">
      <Container>
        <div className="flex flex-col xl:flex-row xl:items-end justify-between gap-8 mb-16">
          <SectionHeading top={hasUpcoming ? "Prochainement" : "Derniers"} bottom={hasUpcoming ? "sur LGTDZ" : "rendez\u2011vous"} testId="home-upcoming-title" />
          <p className="text-zinc-400 max-w-sm">
            Concerts, cartes blanches, battles et émissions live organisés ou soutenus par LGTDZ.
          </p>
        </div>
        {upcoming.isLoading || past.isLoading ? (
          <LoadingGrid />
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-16">
            {events.map((e, i) => <EventCard key={e.id} event={e} index={i} />)}
          </div>
        )}
        <div className="mt-20 flex justify-center">
          <Link
            to="/agenda"
            data-testid="home-see-agenda-btn"
            className="inline-flex items-center gap-3 border-2 border-white text-white font-display uppercase text-2xl px-10 py-5 hover:bg-white hover:text-black transition-colors duration-200"
          >
            Voir l'agenda <ArrowRight className="w-6 h-6" />
          </Link>
        </div>
      </Container>
    </section>
  );
};
